import { render, staticRenderFns } from "./ApoderadoForm.vue?vue&type=template&id=ca492eba&scoped=true"
import script from "./ApoderadoForm.vue?vue&type=script&lang=js"
export * from "./ApoderadoForm.vue?vue&type=script&lang=js"
import style0 from "./ApoderadoForm.vue?vue&type=style&index=0&id=ca492eba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca492eba",
  null
  
)

export default component.exports